@if (flowType === flowTypes.CHARITY) {
  <app-split-screen
    [leadId]="lead?.id"
    [charity]="charity"
    [screening]="charity.screening"
    (close)="hideSplitScreen($event)"
    [openZendesk]="flowService.showZendeskChat.bind(this)"
  ></app-split-screen>
}
@if (leadId && flowType === flowTypes.TERRITORY) {
  <app-organization-landing [flowId]="flowId" [leadId]="leadId" />
}
